import { useAuth } from "@/hooks/useAuth";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ImpersonationBanner } from "@/components/pages/dashboard/ImpersonationBanner";

export default function ProtectedRoute() {
  const { isAuthenticated, authHydrated } = useAuth();

  if (!authHydrated) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <ImpersonationBanner />
      <Outlet />
    </>
  );
}
